import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm0-17.55a.75.75 0 0 1 .75.75v4.05h4.05a.75.75 0 0 1 0 1.5h-4.05v4.05a.75.75 0 0 1-1.5 0v-4.05H7.2a.75.75 0 0 1 0-1.5h4.05V7.2a.75.75 0 0 1 .75-.75Z",
		fill: "#531DAB",
		fillRule: "evenodd",
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M12%2024c6.627%200%2012-5.373%2012-12S18.627%200%2012%200%200%205.373%200%2012s5.373%2012%2012%2012Zm0-17.55a.75.75%200%200%201%20.75.75v4.05h4.05a.75.75%200%200%201%200%201.5h-4.05v4.05a.75.75%200%200%201-1.5%200v-4.05H7.2a.75.75%200%200%201%200-1.5h4.05V7.2a.75.75%200%200%201%20.75-.75Z%22%20fill%3D%22%23531DAB%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
